import {Component, OnInit, ViewEncapsulation, HostListener} from '@angular/core';
import {Location} from '@angular/common';
import {Router, NavigationEnd, ActivatedRoute} from '@angular/router';
import {ConfirmDialogService} from './services/confirm-dialog.service';
import {SharedToolsService} from './services/shared-tools.service';
import {ApiToolsService} from './services/api-tools.service';
import {DataToolsService} from './services/data-tools.service';
import {AnalyticsService} from './services/analytics.service';
import {DataInitService} from "./services/data-init.service";
import { filter } from 'rxjs/operators';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit {
	title = 'koutravo-app';
	loadingUrl: string = "";
	templateImg: string = "";
	previousLabelTxt:any = "";
	nextLabelTxt: string = "";
	type_agent_id: number = 2;
	type_client_id: number = 3;

	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		const windowWidth = event.target.innerWidth;
		if (windowWidth <= 768) {
			this.previousLabelTxt = '<';
			this.nextLabelTxt = '>';
		} else {
			this.previousLabelTxt = this.sharedToolsService.getPaginationLabels('prev');
			this.nextLabelTxt = this.sharedToolsService.getPaginationLabels('next');
		}
	}

	constructor(
		public router: Router,
		public route: ActivatedRoute,
		public location: Location,
		public confirmDialogService: ConfirmDialogService,
		public sharedToolsService: SharedToolsService,
		public apiToolsService: ApiToolsService,
		public dataToolsService: DataToolsService,
		public analyticsService: AnalyticsService,
		public dataInitService: DataInitService
	) {	}

	ngOnInit() {
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe(() => {
			this.initializeSettings();
		});
	}

	private initializeSettings() {
		//this.app.sharedToolsService.returnObjectSwitchRefId()
		let currentCompany = this.sharedToolsService.returnObjectSwitchRefId();
		console.log('currentCompany', currentCompany);

		this.analyticsService.initialize(currentCompany);

		this.sharedToolsService.settings$.subscribe(settings => {
			this.updateLoaderImage(settings);
		});
	}

	private updateLoaderImage(settings: any) {
		const loaderUrl = settings[this.sharedToolsService.returnObjectSwitchRefId()].loader;
		this.loadingUrl = loaderUrl;
		this.templateImg = `<img alt='loader' width='200' src='${this.loadingUrl}' />`;
	}
}
